export function isAcceptanceStatusArray(
  values: unknown,
): values is AcceptanceStatus[] {
  return (
    Array.isArray(values) &&
    values.every((item) => ['pending', 'accepted', 'rejected'].includes(item))
  );
}
